import { LK_PUBLICATIONS_ROUTES } from '@/views/LKPublications/utils'

export default {
  props: {
    value: {
      type: Number,
      default: 1,
    },
    slug: String,
    topicSlug: String,
    loading: Boolean,
  },
  data: () => ({
    tabs: [
      {
        key: 0,
        text: 'Excel',
      },
      {
        key: 1,
        text: 'Форма',
      },
      {
        key: 2,
        text: 'История изменений',
      },
    ],
  }),
  computed: {
    currentPage: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
  methods: {
    onClose() {
      if (this.slug && this.topicSlug) {
        this.$router.push({
          name: LK_PUBLICATIONS_ROUTES.VIEW,
          params: { topic_slug: this.topicSlug, slug: this.slug },
        })
      } else if (this.topicSlug) {
        this.$router.push({
          name: LK_PUBLICATIONS_ROUTES.LIST,
          params: { topic_slug: this.topicSlug },
        })
      } else if (this.slug) {
        this.$router.push({
          name: LK_PUBLICATIONS_ROUTES.VIEW_ONCE,
          params: { slug: this.slug },
        })
      } else {
        this.$router.push({
          name: LK_PUBLICATIONS_ROUTES.LAYOUT,
        }).catch(() => {})
      }
    },
  },
}
